import { DateHelper } from "../util/dateHelper";
import { Log } from "../util/log";
import { AccessMethod } from "./accessMethod";
import { BaseModel } from "./baseModel";
import { Deserializable } from "./deserializable";

export class AccessLogEvent extends BaseModel implements Deserializable {

  code: string;
  context: string;
  createdAt: Date;
  updateAt: Date;
  date: Date;
  deviceSerial: string;
  id: number;
  state: string;
  tableState: string;
  userOwnerId: number;
  userUid: string;
  way: string;
  tableWay: string;
  userOwnerName: string;
  name: string;
  activationCode: string;

  readerCount: number = -1;


  dateFriendly: string;


  deserialize(input: any) {
    super.deserialize(input);
    Object.assign(this, input);

    this.date = DateHelper.parseDate(input.date);
    this.dateFriendly = DateHelper.formatDateTimeFriendly(this.date);

    if (this.userOwnerName == "unknown") {
      this.userOwnerName = $localize`:@@AccessLogEvent_uknown:Sconosciuto`;
    }

    //se way é "Badge1", way deve diventare Badge e readerCount 1
    if (this.way.includes(AccessMethod.EVENT_TYPE_BADGE)) {

      if (this.way.length > AccessMethod.EVENT_TYPE_BADGE.length) {
        this.readerCount = Number(this.way.substr(this.way.length - 1));
      }
      this.way = AccessMethod.EVENT_TYPE_BADGE;
    }

    //se way é "pinCode1", way deve diventare pinCode e readerCount 1
    if (this.way.includes(AccessMethod.EVENT_TYPE_PINCODE)) {

      if (this.way.length > AccessMethod.EVENT_TYPE_PINCODE.length) {
        this.readerCount = Number(this.way.substr(this.way.length - 1));
      }
      this.way = AccessMethod.EVENT_TYPE_PINCODE;

    }

    return this;
  }

  public getDate(): string {

    return DateHelper.formatDateTimeFriendly(this.date);
  }

}
